export default function HowItWorks() {
  const steps = [
    {
      num: "01",
      title: "Get a Custom Proposal",
      desc: "Tell us about your school. We'll visit, assess your needs, and deliver a tailored proposal with pricing built specifically for you. No two schools are the same.",
    },
    {
      num: "02",
      title: "On-Site Setup & Training",
      desc: "Our team comes to your school physically. We set up everything, migrate your data, and train your entire staff hands-on — right at your campus. No Zoom. No guesswork.",
    },
    {
      num: "03",
      title: "Go Live",
      desc: "Your school goes live with full support. Students, parents, and teachers get instant access. We stay with you through the first weeks to ensure a smooth launch.",
    },
  ];

  return (
    <section data-testid="how-it-works-section" className="relative bg-gray-50 py-24 lg:py-32 overflow-hidden">
      <div className="blob-blue" style={{ top: '20%', right: '-10%' }} />
      <div className="blob-pink" style={{ bottom: '-15%', left: '10%' }} />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0A0A0A] mb-4"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="how-it-works-heading"
          >
            How It Works
          </h2>
          <p
            className="text-base text-gray-500 max-w-lg mx-auto font-medium"
            style={{ fontFamily: "'Satoshi', sans-serif" }}
          >
            Get your school running on VelTech in 3 simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {steps.map((step, i) => (
            <div key={step.num} data-testid={`step-${i}`} className="text-center bg-white border-2 border-gray-100 p-10">
              <div
                className="text-7xl font-black text-gray-100 mb-4 leading-none"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {step.num}
              </div>
              <h3
                className="text-xl font-black text-[#0A0A0A] mb-3 tracking-tight uppercase"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {step.title}
              </h3>
              <p
                className="text-sm text-gray-500 leading-relaxed font-medium"
                style={{ fontFamily: "'Satoshi', sans-serif" }}
              >
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
